import React from 'react'
import { withIcon } from '../../withIcon'

function LogoArchitectIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
      <path d="M12.5088 1.97658C12.7942 1.61466 13.3561 1.62772 13.624 2.00294L13.6768 2.08888L22.2793 18.5274C22.5319 19.01 22.16 19.5837 21.6162 19.5508L20.5762 19.4873L21.4893 21.2422C21.7984 21.8372 21.1745 22.4843 20.5684 22.1973L14.0059 19.0899L6.17676 18.6162C5.65236 18.5845 5.34795 18.0081 5.61817 17.5576L12.4531 6.17286L12.5107 6.09083C12.7988 5.73412 13.3566 5.75119 13.6221 6.12501L13.6738 6.21095L20.0391 18.4531L21.1455 18.5205L13.041 3.03224L2.43164 21.21C2.29242 21.4484 1.98649 21.5288 1.74805 21.3897C1.50959 21.2505 1.42923 20.9445 1.56836 20.7061L12.4512 2.06056L12.5088 1.97658ZM20.1904 20.9121L19.4131 19.417L16.6836 19.252L20.1904 20.9121ZM6.72949 17.6475L11.5801 17.9414L9.08692 16.7608C8.70825 16.5815 8.57072 16.112 8.79297 15.7568L12.6416 9.60646C12.7881 9.3724 13.097 9.30086 13.3311 9.44728C13.5651 9.59376 13.6357 9.90264 13.4893 10.1367L9.81836 16.001L14.2578 18.1035L18.875 18.3828L13.0342 7.14747L6.72949 17.6475Z" fill={color}/>
    </svg>
  )
}

export default withIcon(LogoArchitectIcon)
